import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const getCostwidgetdata = createAsyncThunk(
  "getCostwidgetdata",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.REPORT?.GETCOSTWIDGETDATA,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);
export const getMonthlycostbydataby = createAsyncThunk(
  "getMonthlycostbydataby",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.REPORT?.MONTHLYCOSTBYDATABY,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);
export const getMonthlycostbydatabyWorkflowId = createAsyncThunk(
  "getMonthlycostbydatabyWorkflowId",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASEURL +
            API_URL?.REPORT?.MONTHLY_COST_BY_DATA_BY_WORKFLOW_ID,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);
export const getDataCloudHealthCount = createAsyncThunk(
  "getDataCloudHealthCount",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL?.REPORT?.GET_DATA_CLOUD_HEALTH_COUNT +
            `?currentdate=${data?.currentdate}&timezone=${data?.timezone}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);
export const getDashboardDailyActivityData = createAsyncThunk(
  "getDashboardDailyActivityData",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.REPORT?.GET_DAILY_ACTIVITY_DATA,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);
const initialState = {
  getCostwidgetListData: {
    data: null,
    error: null,
  },
  getMonthlycostbydatabyData: {
    data: null,
    error: null,
  },
  getMonthlycostbydatabyWorkflowIdData: {
    data: null,
    error: null,
  },
  getDataCloudHealthCountData: {
    data: null,
    error: null,
  },
  getDashboardDailyActivityData: {
    data: null,
    error: null,
  },
};

const ReportSlice = createSlice({
  name: "Report",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCostwidgetdata.fulfilled, (state, action) => {
        state.getCostwidgetListData.data = action.payload;
      })
      .addCase(getCostwidgetdata.rejected, (state, action) => {
        state.getCostwidgetListData.error = action.error.message;
      })
      .addCase(getMonthlycostbydataby.fulfilled, (state, action) => {
        state.getMonthlycostbydatabyData.data = action.payload;
      })
      .addCase(getMonthlycostbydataby.rejected, (state, action) => {
        state.getMonthlycostbydatabyData.error = action.error.message;
      })
      .addCase(getMonthlycostbydatabyWorkflowId.fulfilled, (state, action) => {
        state.getMonthlycostbydatabyWorkflowIdData.data = action.payload;
      })
      .addCase(getMonthlycostbydatabyWorkflowId.rejected, (state, action) => {
        state.getMonthlycostbydatabyWorkflowIdData.error = action.error.message;
      })
      .addCase(getDataCloudHealthCount.fulfilled, (state, action) => {
        state.getDataCloudHealthCountData.data = action.payload;
      })
      .addCase(getDataCloudHealthCount.rejected, (state, action) => {
        state.getDataCloudHealthCountData.error = action.error.message;
      })
      .addCase(getDashboardDailyActivityData.fulfilled, (state, action) => {
        state.getDashboardDailyActivityData.data = action.payload;
      })
      .addCase(getDashboardDailyActivityData.rejected, (state, action) => {
        state.getDashboardDailyActivityData.error = action.error.message;
      });
  },
});

export default ReportSlice.reducer;
